import { useContext } from "react";

import { TvConnectRemoteContext } from "$src/core/contexts/tv-connect-remote";

const useTvConnectRemote = () => {
  const context = useContext(TvConnectRemoteContext);
  if (!context) {
    throw new Error("TvConnectRemoteContext not found");
  }
  return context;
};

export default useTvConnectRemote;
